import { activeSchemaConnectionUuidAtom } from '@/app/ai/atoms/aiAnalystAtoms/primitives';
import { atom } from 'jotai';

const showStockDataPanelBaseAtom = atom(false);

export const showStockDataPanelAtom = atom(
  (get) => get(showStockDataPanelBaseAtom),
  (get, set, newValue: boolean | ((prev: boolean) => boolean)) => {
    const resolved = typeof newValue === 'function' ? newValue(get(showStockDataPanelBaseAtom)) : newValue;
    if (resolved) {
      set(activeSchemaConnectionUuidAtom, undefined);
    }
    set(showStockDataPanelBaseAtom, resolved);
  }
);
